import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QuerySearchContextsArgs,
  SearchContextsOutput,
  Context,
  ContextsConnection,
} from "types/generated";

export type SearchContextsForNavigationItem = Pick<Context, "id" | "name" | "spaceDetails">;

type SearchContextsForNavigationData = {
  searchContexts: {
    edges: Array<{
      node: SearchContextsForNavigationItem;
      cursor: ContextsConnection["cursor"];
    }>;
    pageInfo: Pick<SearchContextsOutput["pageInfo"], "hasNextPage">;
  };
};

export const SEARCH_CONTEXTS_FOR_NAVIGATION: TypedDocumentNode<
  SearchContextsForNavigationData,
  QuerySearchContextsArgs
> = gql`
  query SearchContextsForNavigation($input: SearchInput!) {
    searchContexts(input: $input) {
      edges {
        node {
          id
          name
          spaceDetails {
            id
            name
            accessLevel
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;
